module.exports = __webpack_public_path__ + "static/media/product-demo-thumbnail.75230766.png";